import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=4999cf62&"
import script from "./UserName.vue?vue&type=script&lang=ts&"
export * from "./UserName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports